import { Box, Button, Divider, styled, Typography } from '@mui/material';

export const AvatarColorContainer = styled(Box)(({ theme }) => ({
  maxWidth: '100%',
  width: '90%',
  margin: 'auto',
  padding: theme.spacing(6, 0),
}));

export const ColorPaletteButton = styled(Button)`
  border: 0;
  background: transparent;
  padding-top: 2rem;
`;

export const StyledTypography = styled(Typography)`
  font-weight: 500;
`;

export const AvatarListIcon = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0),
  svg: {
    cursor: 'pointer',
  },
  [theme.breakpoints.down('sm')]: {
    svg: {
      width: '5rem',
      height: '5rem',
    },
  },
}));

export const AvatarComponent = styled(Box)(({ theme }) => ({
  margin: 'auto',
  [theme.breakpoints.down('md')]: {
    margin: '2rem auto',
  },
}));

export const ChooseAvatarTextForMobiledevice = styled(Typography)(
  ({ theme }) => ({
    fontWeight: '600',
    padding: theme.spacing(0.75),
  })
);

export const DividerStyled = styled(Divider)(({ theme }) => ({
  border: '0.38rem solid #f68848',
  width: '15%',
  textAlign: 'left',
  margin: '-6px 0px 12px 0px',
  borderRadius: '0.625rem',
  [theme.breakpoints.down('sm')]: {
    width: '28%',
  },
}));

export const AvatarSelectionListBox = styled('ul')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  padding: theme.spacing(3, 0),
  listStyleType: 'none',
  marginBottom: 0,
  li: {
    display: 'inline-block',
  },
}));
